// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteUserForm-space1-grmql {
	margin-bottom: 6px !important;
}

.DeleteUserForm-space2-pQ5mG {
	margin-bottom: 12px !important;
}

.DeleteUserForm-space3-lVSyy {
	margin-bottom: 18px !important;
}

.DeleteUserForm-space4-dgKmh {
	margin-bottom: 24px !important;
}

.DeleteUserForm-space5-_OHjX {
	margin-bottom: 30px !important;
}

.DeleteUserForm-space6-eLtJM {
	margin-bottom: 36px !important;
}

.DeleteUserForm-space7-VARUt {
	margin-bottom: 42px !important;
}

.DeleteUserForm-spaceTop8-qFFDZ {
	margin-bottom: 48px !important;
}

.DeleteUserForm-spaceTop1-V9R3f {
	margin-top: 6px !important;
}

.DeleteUserForm-spaceTop2-R3SqN {
	margin-top: 12px !important;
}

.DeleteUserForm-spaceTop3-UIxuu {
	margin-top: 18px !important;
}

.DeleteUserForm-spaceTop4-zfhED {
	margin-top: 24px !important;
}

.DeleteUserForm-spaceTop5-OWJfy {
	margin-top: 30px !important;
}

.DeleteUserForm-spaceTop6-LWgff {
	margin-top: 36px !important;
}

.DeleteUserForm-spaceTop7-PocTr {
	margin-top: 42px !important;
}

.DeleteUserForm-spaceTop8-qFFDZ {
	margin-top: 48px !important;
}

.DeleteUserForm-noMargin-AgWdu {
	margin: 0px !important;
}

.DeleteUserForm-padding1-olW3L {
	padding-bottom: 6px !important;
}

.DeleteUserForm-padding2-OtlHw {
	padding-bottom: 12px !important;
}

.DeleteUserForm-padding3-pRhxb {
	padding-bottom: 18px !important;
}

.DeleteUserForm-padding4-BHeC3 {
	padding-bottom: 24px !important;
}

.DeleteUserForm-padding5-gjOrG {
	padding-bottom: 30px !important;
}

.DeleteUserForm-padding6-LshdN {
	padding-bottom: 36px !important;
}

.DeleteUserForm-padding7-InirT {
	padding-bottom: 42px !important;
}

.DeleteUserForm-paddingTop1-M8KsM {
	padding-top: 6px !important;
}

.DeleteUserForm-paddingTop2-gP8_h {
	padding-top: 12px !important;
}

.DeleteUserForm-paddingTop3-CO2E8 {
	padding-top: 18px !important;
}

.DeleteUserForm-paddingTop4-QBb9W {
	padding-top: 24px !important;
}

.DeleteUserForm-paddingTop5-YeRdA {
	padding-top: 30px !important;
}

.DeleteUserForm-paddingTop6-cyc_w {
	padding-top: 36px !important;
}

.DeleteUserForm-paddingTop7-gveMN {
	padding-top: 42px !important;
}

.DeleteUserForm-noPadding-jaPJ0 {
	padding: 0px !important;
}

.DeleteUserForm-textBold-d5NHf {
	font-weight: 500 !important;
}

.DeleteUserForm-textBolder-g1hHj {
	font-weight: 700 !important;
}

.DeleteUserForm-textNormal-aYGT2 {
	font-weight: normal !important;
}

.DeleteUserForm-spaceBottom20-QTqkq {
	margin-bottom: 20px;
}

.DeleteUserForm-spaceBottom10-B5DSn {
	margin-bottom: 10px;
}

.DeleteUserForm-marginNone-r_H9h {
	margin: 0;
}

.DeleteUserForm-spaceBottom15-W1Paj {
	margin-bottom: 15px;
}

.DeleteUserForm-marginTopNone-qDvfh {
	margin-top: 0;
}

.DeleteUserForm-spaceTop11-TKRpn {
	margin-top: 11px;
}

.DeleteUserForm-spaceTop21-WSNKK {
	margin-top: 21px;
}

.DeleteUserForm-spaceTop20-cAEi7 {
	margin-top: 20px;
}

.DeleteUserForm-spaceTop10-Yv6Cf {
	margin-top: 10px;
}

/*New Design Text Colors */

.DeleteUserForm-textDarkBlue-M_v7q {
	color: rgb(20, 39, 94) !important;
}

.DeleteUserForm-textLightBlue-EvEIT {
	color: rgb(57, 87, 106) !important;
}

.DeleteUserForm-textLightSandleGreen-Gy7Ik {
	color: rgb(76, 86, 41) !important;
}

.DeleteUserForm-textLightBrown-qP91z {
	color: rgb(115, 79, 33) !important;
}

.DeleteUserForm-textMediumMaroon-vyfW0 {
	color: rgb(87, 37, 51) !important;
}

.DeleteUserForm-textBrown-txT3p {
	color: rgb(160, 47, 24) !important;
}

.DeleteUserForm-textMaroon-EJS8p {
	color: rgb(155, 49, 67) !important;
}

.DeleteUserForm-textDarkBrown-LuTKU {
	color: rgb(83, 18, 16) !important;
}

.DeleteUserForm-textMediumBrown-unwZ7 {
	color: rgb(142, 28, 10) !important;
}

.DeleteUserForm-textSkyBlue-yZXBk {
	color: rgb(37, 117, 141) !important;
}

.DeleteUserForm-textGray-yWM8o {
	color: rgb(77, 65, 51) !important;
}

.DeleteUserForm-btnPrimary-nnODG {
  display: inline-block;
  border-color: var(--primary-bg);
  background-color: var(--primary-color);
  color: var(--white-color);
  padding: 7px 21px;
  font-weight: 600;
  font-size: 18px;
  border-radius: 9999px;
  -webkit-box-shadow: none;
          box-shadow: none;
  text-decoration: none !important;
  cursor: pointer;
  white-space: normal;
  font-family: var(--font-family-base);
}

.DeleteUserForm-btnPrimary-nnODG:hover,
.DeleteUserForm-btnPrimary-nnODG:focus,
.DeleteUserForm-btnPrimary-nnODG:active,
.DeleteUserForm-btnPrimary-nnODG:active:hover,
.DeleteUserForm-btnPrimary-nnODG:active:focus {
  border-color: var(--primary-bg-hover);
  background-color: var(--primary-bg-hover);
  color: var(--primary-btn-foreground);
  -webkit-box-shadow: none;
          box-shadow: none;
}

.DeleteUserForm-btnPrimaryBorder-G_Lkh {
  border-color: var(--secondary-oscuro);
  color: var(--secondary-oscuro) !important;
  font-family: var(--font-family-base);
  background-color: transparent !important;
  padding: 7px 21px;
  font-weight: 600;
  font-size: 18px;
  border-radius: 9999px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  border: 1px solid !important;
  cursor: pointer;
  white-space: normal;
}

.DeleteUserForm-btnPrimaryBorder-G_Lkh:hover,
.DeleteUserForm-btnPrimaryBorder-G_Lkh:focus,
.DeleteUserForm-btnPrimaryBorder-G_Lkh:active,
.DeleteUserForm-btnPrimaryBorder-G_Lkh:active:hover,
.DeleteUserForm-btnPrimaryBorder-G_Lkh:active:focus {
  border-color: var(--primary-bg);
  color: var(--primary-bg);
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.DeleteUserForm-btnPrimaryLink-ORFKJ {
  border: 1px solid var(--primary-bg) !important;
}

.DeleteUserForm-btnLarge-xZJko {
  padding: 9px 21px !important;
}

.DeleteUserForm-btnSmall-bX2pr {
  padding: 5px 0px;
}

.DeleteUserForm-btnBig-V0zuu {
  padding: 13px 21px !important;
}

.DeleteUserForm-fullWidth-b7BpN {
  width: 100%;
}

.DeleteUserForm-noTextDecration-HE15O {
  text-decoration: none !important;
}

.DeleteUserForm-textAlignRight-jCT0Y {
  text-align: right;
}

.DeleteUserForm-textEnd-GPOca {
  text-align: end;
}

.DeleteUserForm-textAlignCenter-W6Rzd {
  text-align: center;
}

.DeleteUserForm-commonControlInput-o1Q6u {
  padding: 10px 15px 10px 15px;
  height: 58px;
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-input-bg);
  color: var(--primary-foreground);
  -webkit-box-shadow: none;
          box-shadow: none;
}

.DeleteUserForm-commonControlSelect-Lg234 {
  padding: 10px 35px 10px 15px;
  height: 58px;
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-input-bg);
  color: var(--primary-foreground);
  display: block;
  overflow: hidden;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  background-position: calc(100% - 5px) 50%;
  background-size: 30px 30px !important;
}

.DeleteUserForm-commonControlTextArea-gz_Uz {
  padding: 10px 15px 10px 15px;
  height: 92px !important;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-input-bg);
  color: var(--primary-foreground);
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  -webkit-box-shadow: none;
          box-shadow: none;
}

.DeleteUserForm-noTextDecoration-eFVu2 {
  text-decoration: none !important;
}

.DeleteUserForm-fontWeightNormal-tiqj9 {
  font-weight: normal;
}

.DeleteUserForm-fontWeightMedium-OZdCk {
  font-weight: 500;
}

.DeleteUserForm-fontWeightSemiBold-Vegbn {
  font-weight: 600;
}

.DeleteUserForm-fontWeightBold-gu3WE {
  font-weight: 700;
}

/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */

.DeleteUserForm-picContainerMain-xm9FQ {
  padding: 30px;
  -webkit-box-shadow: 0px 0px 15px 0px var(--primary-box-shadow);
          box-shadow: 0px 0px 15px 0px var(--primary-box-shadow);
  border-radius: 4px;
  position: relative;
}

.DeleteUserForm-profilePic-xAgNw {
  border-radius: 100px;
}

.DeleteUserForm-trashIcon-UL13D {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  background: var(--common-black-primary-bg);
  padding-top: 3px;
  border: 0;
  border-radius: 2px;
  opacity: .9;
  color: var(--common-primary-white-foreground);
  cursor: pointer;
}

.DeleteUserForm-trashIconNew-whhmo {
  position: absolute;
  top: -14px;
  right: -14px;
}

.DeleteUserForm-profileImageBg-QTT1a {
  padding-top: 60%;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 4px;
  background-color: var(--tertiary-gray-bg);
  border: 1px dashed var(--secondary-border);
  background-position: center;
}

.DeleteUserForm-cursorPointer-OP1xP {
  cursor: pointer;
}

.DeleteUserForm-listingTitleText-_2X3I {
  margin: 0px 0px 18px 0px;
  font-size: 22px;
  font-weight: 600;
}

.DeleteUserForm-trustBtnLarge-_xGfJ {
  padding: 9px 15px;
}

/*-----------------------Profilephoto Upload Common Styles End----------------------------- */

.DeleteUserForm-noMargin-AgWdu {
  margin: 0px;
}

.DeleteUserForm-spaceTop1-V9R3f {
  margin-top: 6px;
}

.DeleteUserForm-spaceTop2-R3SqN {
  margin-top: 12px;
}

.DeleteUserForm-spaceTop3-UIxuu {
  margin-top: 18px;
}

.DeleteUserForm-spaceTop5-OWJfy {
  margin-top: 30px;
}

.DeleteUserForm-spaceTop4-zfhED {
  margin-top: 24px;
}

.DeleteUserForm-space1-grmql {
  margin-bottom: 6px;
}

.DeleteUserForm-space2-pQ5mG {
  margin-bottom: 12px;
}

.DeleteUserForm-space3-lVSyy {
  margin-bottom: 18px;
}

.DeleteUserForm-space4-dgKmh {
  margin-bottom: 24px;
}

.DeleteUserForm-space5-_OHjX {
  margin-bottom: 30px;
}

/*----------------------Password Show Icon Section ------------------------------*/

.DeleteUserForm-pwdImage-SPG5s {
  position: absolute;
  right: 20px;
  top: 54px;
  cursor: pointer;
}

.DeleteUserForm-pwdSection-lpkkG {
  position: relative;
}

.DeleteUserForm-loginPwdSection-kxYAU {
  top: 50px;
}

.DeleteUserForm-commonLabelText-ZQBKH {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 0 6px;
  text-align: start;
  color: var(--primary-foreground);
}

.DeleteUserForm-loginLabel-z2i33 {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: 600;
}

.DeleteUserForm-errorMessage-hqOur {
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

/*----------------------Phone-Input Field Start------------------------------*/

.DeleteUserForm-editPhoneInputSection-vsAy8 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
  -webkit-column-gap: 20px;
     -moz-column-gap: 20px;
          column-gap: 20px;
}

.DeleteUserForm-phoneInputWidth-dSBDB {
  width: 100%;
}

/*----------------------Phone-Input Field Start------------------------------*/

.DeleteUserForm-noPadding-jaPJ0 {
  padding: 0px;
}

.DeleteUserForm-flexEnd-IDnob {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.DeleteUserForm-flexCenter-UsHCi {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
}

.DeleteUserForm-displayFlex-J1aG6 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.DeleteUserForm-alignCenter-cn2Ai {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.DeleteUserForm-flexWrap-PDAum {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.DeleteUserForm-justifyContentCenter-eCX5W {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.DeleteUserForm-justifyContentFlexEnd-kQXV8 {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.DeleteUserForm-justifyContentSpaceBetween-RuoNZ {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.DeleteUserForm-positionRelative-WHA6Y {
  position: relative;
}

.DeleteUserForm-alignFlexStart-hgIaX {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.DeleteUserForm-alignBaseline-uQ_yJ {
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
}

.DeleteUserForm-flexShrinkNone-BvfRw {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.DeleteUserForm-gap4-bFAt7 {
  gap: 4px;
}

.DeleteUserForm-gap8-o_Ask {
  gap: 8px;
}

.DeleteUserForm-gap12-uA6FG {
  gap: 12px;
}

.DeleteUserForm-gap16-oV9fM {
  gap: 16px;
}

.DeleteUserForm-gap24-bwQ8X {
  gap: 24px;
}

.DeleteUserForm-siteTextColor-NvniR,
.DeleteUserForm-siteTextColor-NvniR:hover,
.DeleteUserForm-siteTextColor-NvniR:focus,
.DeleteUserForm-siteTextColor-NvniR:active {
  color: var(--primary-foreground);
}

.DeleteUserForm-defaultImg-BDYun {
  background-size: 30%;
}

.DeleteUserForm-requiedBorder-gyLgp {
  height: 94px !important;
}

.DeleteUserForm-loaderFlex-zSAfd {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-column-gap: 3px;
     -moz-column-gap: 3px;
          column-gap: 3px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.DeleteUserForm-displayInlineBlock-DtFUT {
  display: inline-block;
}

@media screen and (max-width:767px) {
  .DeleteUserForm-editPhoneInputSection-vsAy8 {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    row-gap: 20px;
  }
}

.DeleteUserForm-loaderButtonFlex-a6WMR {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 3px;
}

.DeleteUserForm-btnFlexContainerEnd-xExKL {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.DeleteUserForm-displayGrid-jBKUk {
  display: grid;
}

.DeleteUserForm-gridCols2-tZaQ6 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media screen and (max-width: 991px) {
  .DeleteUserForm-gridColsTab1-S60wI {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .DeleteUserForm-gapTab0-zzcqe {
    gap: 0px !important;
  }
}

@media screen and (max-width: 767px) {
  .DeleteUserForm-gridColsMobile1-Sj54l {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

.DeleteUserForm-deleteButtonContainer-AwqWy {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    margin-top: 30px;
    gap: 15px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.DeleteUserForm-textEnd-GPOca {
    text-align: start;
}

.DeleteUserForm-root-Ldr10 {
    padding: 20px;
}

.DeleteUserForm-modalContent-bzPJx {
    font-size: 16px;
    text-align: start;
}

.DeleteUserForm-whiteSpaceNormal-fnO5o {
    white-space: normal;
}

.DeleteUserForm-deleteMessageContent-dNabP {
    margin-bottom: 18px;
    font-size: 14px;
    color: var(--secondary-foreground);
}

.DeleteUserForm-deleteMessageContentLabel-d_QL5 {
    font-weight: 500;
    color: var(--primary-foreground);
}

.DeleteUserForm-deleteButton-x4ODS,
.DeleteUserForm-deleteButton-x4ODS:hover,
.DeleteUserForm-deleteButton-x4ODS:focus,
.DeleteUserForm-deleteButton-x4ODS:active {
    color: var(--primary-link-foreground) !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 5px;
    border: 0px;
    border-bottom: 1px solid var(--primary-link-foreground);
    border-radius: 0;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    font-size: 16px;
    padding: 0px !important;
    font-weight: 500;
    line-height: 19px;
    background: transparent !important;
    -webkit-box-shadow: none !important;
            box-shadow: none !important;
}

.DeleteUserForm-arrowIcon-jopaR {
    width: 6px;
    height: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/commonStyle.css","webpack://./src/components/DeleteUser/DeleteUserForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,wBAAgB;UAAhB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;;;;EAKE,qCAAqC;EACrC,yCAAyC;EACzC,oCAAoC;EACpC,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,oCAAoC;EACpC,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,+BAA+B;EAC/B,wBAAwB;EACxB,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,yCAAyC;EACzC,gCAAgC;EAChC,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,yCAAyC;EACzC,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,mCAA2B;UAA3B,2BAA2B;EAC3B,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,kDAAkD;EAClD,yCAAyC;EACzC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+FAA+F;;AAC/F;EACE,aAAa;EACb,8DAAsD;UAAtD,sDAAsD;EACtD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6FAA6F;;AAC7F;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kFAAkF;;AAClF;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA,8EAA8E;;AAC9E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,6BAAgB;MAAhB,gBAAgB;EAChB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,8EAA8E;;AAC9E;EACE,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AC9bA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,WAAW;IACX,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;;;;IAII,gDAAgD;IAChD,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,QAAQ;IACR,WAAW;IACX,uDAAuD;IACvD,gBAAgB;IAChB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,mCAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".btnPrimary {\n  display: inline-block;\n  border-color: var(--primary-bg);\n  background-color: var(--primary-color);\n  color: var(--white-color);\n  padding: 7px 21px;\n  font-weight: 600;\n  font-size: 18px;\n  border-radius: 9999px;\n  box-shadow: none;\n  text-decoration: none !important;\n  cursor: pointer;\n  white-space: normal;\n  font-family: var(--font-family-base);\n}\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n  border-color: var(--primary-bg-hover);\n  background-color: var(--primary-bg-hover);\n  color: var(--primary-btn-foreground);\n  box-shadow: none;\n}\n\n.btnPrimaryBorder {\n  border-color: var(--secondary-oscuro);\n  color: var(--secondary-oscuro) !important;\n  font-family: var(--font-family-base);\n  background-color: transparent !important;\n  padding: 7px 21px;\n  font-weight: 600;\n  font-size: 18px;\n  border-radius: 9999px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  border: 1px solid !important;\n  cursor: pointer;\n  white-space: normal;\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n  border-color: var(--primary-bg);\n  color: var(--primary-bg);\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryLink {\n  border: 1px solid var(--primary-bg) !important;\n}\n\n.btnLarge {\n  padding: 9px 21px !important;\n}\n\n.btnSmall {\n  padding: 5px 0px;\n}\n\n.btnBig {\n  padding: 13px 21px !important;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.noTextDecration {\n  text-decoration: none !important;\n}\n\n.textAlignRight {\n  text-align: right;\n}\n\n.textEnd {\n  text-align: end;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.commonControlInput {\n  padding: 10px 15px 10px 15px;\n  height: 58px;\n  border-radius: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: normal;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-input-bg);\n  color: var(--primary-foreground);\n  box-shadow: none;\n}\n\n.commonControlSelect {\n  padding: 10px 35px 10px 15px;\n  height: 58px;\n  border-radius: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: normal;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-input-bg);\n  color: var(--primary-foreground);\n  display: block;\n  overflow: hidden;\n  appearance: none;\n  box-shadow: none !important;\n  background-position: calc(100% - 5px) 50%;\n  background-size: 30px 30px !important;\n}\n\n.commonControlTextArea {\n  padding: 10px 15px 10px 15px;\n  height: 92px !important;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-input-bg);\n  color: var(--primary-foreground);\n  border-radius: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: normal;\n  box-shadow: none;\n}\n\n.noTextDecoration {\n  text-decoration: none !important;\n}\n\n.fontWeightNormal {\n  font-weight: normal;\n}\n\n.fontWeightMedium {\n  font-weight: 500;\n}\n\n.fontWeightSemiBold {\n  font-weight: 600;\n}\n\n.fontWeightBold {\n  font-weight: 700;\n}\n\n/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */\n.picContainerMain {\n  padding: 30px;\n  box-shadow: 0px 0px 15px 0px var(--primary-box-shadow);\n  border-radius: 4px;\n  position: relative;\n}\n\n.profilePic {\n  border-radius: 100px;\n}\n\n.trashIcon {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 22px;\n  height: 22px;\n  background: var(--common-black-primary-bg);\n  padding-top: 3px;\n  border: 0;\n  border-radius: 2px;\n  opacity: .9;\n  color: var(--common-primary-white-foreground);\n  cursor: pointer;\n}\n\n.trashIconNew {\n  position: absolute;\n  top: -14px;\n  right: -14px;\n}\n\n.profileImageBg {\n  padding-top: 60%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  border-radius: 4px;\n  background-color: var(--tertiary-gray-bg);\n  border: 1px dashed var(--secondary-border);\n  background-position: center;\n}\n\n.cursorPointer {\n  cursor: pointer;\n}\n\n.listingTitleText {\n  margin: 0px 0px 18px 0px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.trustBtnLarge {\n  padding: 9px 15px;\n}\n\n/*-----------------------Profilephoto Upload Common Styles End----------------------------- */\n.noMargin {\n  margin: 0px;\n}\n\n.spaceTop1 {\n  margin-top: 6px;\n}\n\n.spaceTop2 {\n  margin-top: 12px;\n}\n\n.spaceTop3 {\n  margin-top: 18px;\n}\n\n.spaceTop5 {\n  margin-top: 30px;\n}\n\n.spaceTop4 {\n  margin-top: 24px;\n}\n\n.space1 {\n  margin-bottom: 6px;\n}\n\n.space2 {\n  margin-bottom: 12px;\n}\n\n.space3 {\n  margin-bottom: 18px;\n}\n\n.space4 {\n  margin-bottom: 24px;\n}\n\n.space5 {\n  margin-bottom: 30px;\n}\n\n/*----------------------Password Show Icon Section ------------------------------*/\n.pwdImage {\n  position: absolute;\n  right: 20px;\n  top: 54px;\n  cursor: pointer;\n}\n\n.pwdSection {\n  position: relative;\n}\n\n.loginPwdSection {\n  top: 50px;\n}\n\n.commonLabelText {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  margin: 0 0 6px;\n  text-align: start;\n  color: var(--primary-foreground);\n}\n\n.loginLabel {\n  font-size: 16px;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.errorMessage {\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}\n\n/*----------------------Phone-Input Field Start------------------------------*/\n.editPhoneInputSection {\n  display: flex;\n  flex-basis: 100%;\n  column-gap: 20px;\n}\n\n.phoneInputWidth {\n  width: 100%;\n}\n\n/*----------------------Phone-Input Field Start------------------------------*/\n.noPadding {\n  padding: 0px;\n}\n\n.flexEnd {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.flexCenter {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.alignCenter {\n  align-items: center;\n}\n\n.flexWrap {\n  flex-wrap: wrap;\n}\n\n.justifyContentCenter {\n  justify-content: center;\n}\n\n.justifyContentFlexEnd {\n  justify-content: flex-end;\n}\n\n.justifyContentSpaceBetween {\n  justify-content: space-between;\n}\n\n.positionRelative {\n  position: relative;\n}\n\n.alignFlexStart {\n  align-items: flex-start;\n}\n\n.alignBaseline {\n  align-items: baseline;\n}\n\n.flexShrinkNone {\n  flex-shrink: 0;\n}\n\n.gap4 {\n  gap: 4px;\n}\n\n.gap8 {\n  gap: 8px;\n}\n\n.gap12 {\n  gap: 12px;\n}\n\n.gap16 {\n  gap: 16px;\n}\n\n.gap24 {\n  gap: 24px;\n}\n\n.siteTextColor,\n.siteTextColor:hover,\n.siteTextColor:focus,\n.siteTextColor:active {\n  color: var(--primary-foreground);\n}\n\n.defaultImg {\n  background-size: 30%;\n}\n\n.requiedBorder {\n  height: 94px !important;\n}\n\n.loaderFlex {\n  display: flex;\n  column-gap: 3px;\n  align-items: center;\n}\n\n.displayInlineBlock {\n  display: inline-block;\n}\n\n@media screen and (max-width:767px) {\n  .editPhoneInputSection {\n    flex-direction: column;\n    row-gap: 20px;\n  }\n}\n\n.loaderButtonFlex {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n}\n\n.btnFlexContainerEnd {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.displayGrid {\n  display: grid;\n}\n\n.gridCols2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n@media screen and (max-width: 991px) {\n  .gridColsTab1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .gapTab0 {\n    gap: 0px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .gridColsMobile1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n}","@import '../../components/helpers.css';\n@import '../../components/commonStyle.css';\n\n.deleteButtonContainer {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    margin-top: 30px;\n    gap: 15px;\n    flex-wrap: wrap;\n}\n\n.textEnd {\n    text-align: start;\n}\n\n.root {\n    padding: 20px;\n}\n\n.modalContent {\n    font-size: 16px;\n    text-align: start;\n}\n\n.whiteSpaceNormal {\n    white-space: normal;\n}\n\n.deleteMessageContent {\n    margin-bottom: 18px;\n    font-size: 14px;\n    color: var(--secondary-foreground);\n}\n\n.deleteMessageContentLabel {\n    font-weight: 500;\n    color: var(--primary-foreground);\n}\n\n.deleteButton,\n.deleteButton:hover,\n.deleteButton:focus,\n.deleteButton:active {\n    color: var(--primary-link-foreground) !important;\n    display: flex;\n    gap: 5px;\n    border: 0px;\n    border-bottom: 1px solid var(--primary-link-foreground);\n    border-radius: 0;\n    align-items: center;\n    font-size: 16px;\n    padding: 0px !important;\n    font-weight: 500;\n    line-height: 19px;\n    background: transparent !important;\n    box-shadow: none !important;\n}\n\n.arrowIcon {\n    width: 6px;\n    height: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `DeleteUserForm-space1-grmql`,
	"space2": `DeleteUserForm-space2-pQ5mG`,
	"space3": `DeleteUserForm-space3-lVSyy`,
	"space4": `DeleteUserForm-space4-dgKmh`,
	"space5": `DeleteUserForm-space5-_OHjX`,
	"space6": `DeleteUserForm-space6-eLtJM`,
	"space7": `DeleteUserForm-space7-VARUt`,
	"spaceTop8": `DeleteUserForm-spaceTop8-qFFDZ`,
	"spaceTop1": `DeleteUserForm-spaceTop1-V9R3f`,
	"spaceTop2": `DeleteUserForm-spaceTop2-R3SqN`,
	"spaceTop3": `DeleteUserForm-spaceTop3-UIxuu`,
	"spaceTop4": `DeleteUserForm-spaceTop4-zfhED`,
	"spaceTop5": `DeleteUserForm-spaceTop5-OWJfy`,
	"spaceTop6": `DeleteUserForm-spaceTop6-LWgff`,
	"spaceTop7": `DeleteUserForm-spaceTop7-PocTr`,
	"noMargin": `DeleteUserForm-noMargin-AgWdu`,
	"padding1": `DeleteUserForm-padding1-olW3L`,
	"padding2": `DeleteUserForm-padding2-OtlHw`,
	"padding3": `DeleteUserForm-padding3-pRhxb`,
	"padding4": `DeleteUserForm-padding4-BHeC3`,
	"padding5": `DeleteUserForm-padding5-gjOrG`,
	"padding6": `DeleteUserForm-padding6-LshdN`,
	"padding7": `DeleteUserForm-padding7-InirT`,
	"paddingTop1": `DeleteUserForm-paddingTop1-M8KsM`,
	"paddingTop2": `DeleteUserForm-paddingTop2-gP8_h`,
	"paddingTop3": `DeleteUserForm-paddingTop3-CO2E8`,
	"paddingTop4": `DeleteUserForm-paddingTop4-QBb9W`,
	"paddingTop5": `DeleteUserForm-paddingTop5-YeRdA`,
	"paddingTop6": `DeleteUserForm-paddingTop6-cyc_w`,
	"paddingTop7": `DeleteUserForm-paddingTop7-gveMN`,
	"noPadding": `DeleteUserForm-noPadding-jaPJ0`,
	"textBold": `DeleteUserForm-textBold-d5NHf`,
	"textBolder": `DeleteUserForm-textBolder-g1hHj`,
	"textNormal": `DeleteUserForm-textNormal-aYGT2`,
	"spaceBottom20": `DeleteUserForm-spaceBottom20-QTqkq`,
	"spaceBottom10": `DeleteUserForm-spaceBottom10-B5DSn`,
	"marginNone": `DeleteUserForm-marginNone-r_H9h`,
	"spaceBottom15": `DeleteUserForm-spaceBottom15-W1Paj`,
	"marginTopNone": `DeleteUserForm-marginTopNone-qDvfh`,
	"spaceTop11": `DeleteUserForm-spaceTop11-TKRpn`,
	"spaceTop21": `DeleteUserForm-spaceTop21-WSNKK`,
	"spaceTop20": `DeleteUserForm-spaceTop20-cAEi7`,
	"spaceTop10": `DeleteUserForm-spaceTop10-Yv6Cf`,
	"textDarkBlue": `DeleteUserForm-textDarkBlue-M_v7q`,
	"textLightBlue": `DeleteUserForm-textLightBlue-EvEIT`,
	"textLightSandleGreen": `DeleteUserForm-textLightSandleGreen-Gy7Ik`,
	"textLightBrown": `DeleteUserForm-textLightBrown-qP91z`,
	"textMediumMaroon": `DeleteUserForm-textMediumMaroon-vyfW0`,
	"textBrown": `DeleteUserForm-textBrown-txT3p`,
	"textMaroon": `DeleteUserForm-textMaroon-EJS8p`,
	"textDarkBrown": `DeleteUserForm-textDarkBrown-LuTKU`,
	"textMediumBrown": `DeleteUserForm-textMediumBrown-unwZ7`,
	"textSkyBlue": `DeleteUserForm-textSkyBlue-yZXBk`,
	"textGray": `DeleteUserForm-textGray-yWM8o`,
	"btnPrimary": `DeleteUserForm-btnPrimary-nnODG`,
	"btnPrimaryBorder": `DeleteUserForm-btnPrimaryBorder-G_Lkh`,
	"btnPrimaryLink": `DeleteUserForm-btnPrimaryLink-ORFKJ`,
	"btnLarge": `DeleteUserForm-btnLarge-xZJko`,
	"btnSmall": `DeleteUserForm-btnSmall-bX2pr`,
	"btnBig": `DeleteUserForm-btnBig-V0zuu`,
	"fullWidth": `DeleteUserForm-fullWidth-b7BpN`,
	"noTextDecration": `DeleteUserForm-noTextDecration-HE15O`,
	"textAlignRight": `DeleteUserForm-textAlignRight-jCT0Y`,
	"textEnd": `DeleteUserForm-textEnd-GPOca`,
	"textAlignCenter": `DeleteUserForm-textAlignCenter-W6Rzd`,
	"commonControlInput": `DeleteUserForm-commonControlInput-o1Q6u`,
	"commonControlSelect": `DeleteUserForm-commonControlSelect-Lg234`,
	"commonControlTextArea": `DeleteUserForm-commonControlTextArea-gz_Uz`,
	"noTextDecoration": `DeleteUserForm-noTextDecoration-eFVu2`,
	"fontWeightNormal": `DeleteUserForm-fontWeightNormal-tiqj9`,
	"fontWeightMedium": `DeleteUserForm-fontWeightMedium-OZdCk`,
	"fontWeightSemiBold": `DeleteUserForm-fontWeightSemiBold-Vegbn`,
	"fontWeightBold": `DeleteUserForm-fontWeightBold-gu3WE`,
	"picContainerMain": `DeleteUserForm-picContainerMain-xm9FQ`,
	"profilePic": `DeleteUserForm-profilePic-xAgNw`,
	"trashIcon": `DeleteUserForm-trashIcon-UL13D`,
	"trashIconNew": `DeleteUserForm-trashIconNew-whhmo`,
	"profileImageBg": `DeleteUserForm-profileImageBg-QTT1a`,
	"cursorPointer": `DeleteUserForm-cursorPointer-OP1xP`,
	"listingTitleText": `DeleteUserForm-listingTitleText-_2X3I`,
	"trustBtnLarge": `DeleteUserForm-trustBtnLarge-_xGfJ`,
	"pwdImage": `DeleteUserForm-pwdImage-SPG5s`,
	"pwdSection": `DeleteUserForm-pwdSection-lpkkG`,
	"loginPwdSection": `DeleteUserForm-loginPwdSection-kxYAU`,
	"commonLabelText": `DeleteUserForm-commonLabelText-ZQBKH`,
	"loginLabel": `DeleteUserForm-loginLabel-z2i33`,
	"errorMessage": `DeleteUserForm-errorMessage-hqOur`,
	"editPhoneInputSection": `DeleteUserForm-editPhoneInputSection-vsAy8`,
	"phoneInputWidth": `DeleteUserForm-phoneInputWidth-dSBDB`,
	"flexEnd": `DeleteUserForm-flexEnd-IDnob`,
	"flexCenter": `DeleteUserForm-flexCenter-UsHCi`,
	"displayFlex": `DeleteUserForm-displayFlex-J1aG6`,
	"alignCenter": `DeleteUserForm-alignCenter-cn2Ai`,
	"flexWrap": `DeleteUserForm-flexWrap-PDAum`,
	"justifyContentCenter": `DeleteUserForm-justifyContentCenter-eCX5W`,
	"justifyContentFlexEnd": `DeleteUserForm-justifyContentFlexEnd-kQXV8`,
	"justifyContentSpaceBetween": `DeleteUserForm-justifyContentSpaceBetween-RuoNZ`,
	"positionRelative": `DeleteUserForm-positionRelative-WHA6Y`,
	"alignFlexStart": `DeleteUserForm-alignFlexStart-hgIaX`,
	"alignBaseline": `DeleteUserForm-alignBaseline-uQ_yJ`,
	"flexShrinkNone": `DeleteUserForm-flexShrinkNone-BvfRw`,
	"gap4": `DeleteUserForm-gap4-bFAt7`,
	"gap8": `DeleteUserForm-gap8-o_Ask`,
	"gap12": `DeleteUserForm-gap12-uA6FG`,
	"gap16": `DeleteUserForm-gap16-oV9fM`,
	"gap24": `DeleteUserForm-gap24-bwQ8X`,
	"siteTextColor": `DeleteUserForm-siteTextColor-NvniR`,
	"defaultImg": `DeleteUserForm-defaultImg-BDYun`,
	"requiedBorder": `DeleteUserForm-requiedBorder-gyLgp`,
	"loaderFlex": `DeleteUserForm-loaderFlex-zSAfd`,
	"displayInlineBlock": `DeleteUserForm-displayInlineBlock-DtFUT`,
	"loaderButtonFlex": `DeleteUserForm-loaderButtonFlex-a6WMR`,
	"btnFlexContainerEnd": `DeleteUserForm-btnFlexContainerEnd-xExKL`,
	"displayGrid": `DeleteUserForm-displayGrid-jBKUk`,
	"gridCols2": `DeleteUserForm-gridCols2-tZaQ6`,
	"gridColsTab1": `DeleteUserForm-gridColsTab1-S60wI`,
	"gapTab0": `DeleteUserForm-gapTab0-zzcqe`,
	"gridColsMobile1": `DeleteUserForm-gridColsMobile1-Sj54l`,
	"deleteButtonContainer": `DeleteUserForm-deleteButtonContainer-AwqWy`,
	"root": `DeleteUserForm-root-Ldr10`,
	"modalContent": `DeleteUserForm-modalContent-bzPJx`,
	"whiteSpaceNormal": `DeleteUserForm-whiteSpaceNormal-fnO5o`,
	"deleteMessageContent": `DeleteUserForm-deleteMessageContent-dNabP`,
	"deleteMessageContentLabel": `DeleteUserForm-deleteMessageContentLabel-d_QL5`,
	"deleteButton": `DeleteUserForm-deleteButton-x4ODS`,
	"arrowIcon": `DeleteUserForm-arrowIcon-jopaR`
};
module.exports = ___CSS_LOADER_EXPORT___;
